import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BookingSearchSubHeaderComponent } from './booking-search-sub-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [BookingSearchSubHeaderComponent],
  imports: [CommonModule, TranslateModule, StaticMsgModule],
  exports: [BookingSearchSubHeaderComponent],
})
export class BookingSearchSubHeaderModule {}
